/* global jQuery, DOMParser, alert */

import { Module } from 'wrapper6'
import { mttAjax } from 'utils/_mtt_ajax'
import GA4Tracking from 'app/GA4/utils/ga4-tracking'

export default class MiniCartHandler extends Module {
  ready () {
    this.cartIcon = document.querySelector('.mtt-open-cart')
    this.miniCart = document.querySelector('.menu-mini-cart')

    if (this.cartIcon) {
      this.handleOpenMiniCart()
    }
  }

  handleOpenMiniCart () {
    this.jQueryMenuMiniCart = jQuery('.menu-mini-cart')
    this.cartItemAttributeUls = document.querySelectorAll('.variation')

    this.updateAttributeLists()

    this.jQueryMenuMiniCart.on('click', 'button.minus-qty', (e) => {
      this.handleMinusClick(e.target)
    })

    this.jQueryMenuMiniCart.on('click', 'button.plus-qty', (e) => {
      this.handlePlusClick(e.target)
    })

    this.jQueryMenuMiniCart.on('click', 'a.woocommerce-mini-cart-item__remove', (e) => {
      this.handleRemoveClick(e.target)
    })

    this.jQueryMenuMiniCart.on('click', '.variation [data-variation]', (e) => {
      this.handleChangeTerms(e.target)
    })

    this.jQueryMenuMiniCart.on('click', '[data-update_info] .update-variation-button', (e) => {
      this.handleUpdateTerms(e.target)
    })
  }

  updateAttributeLists () {
    const cartItems = jQuery('.mini_cart_item')
    for (let i = 0; i < cartItems.length; i++) {
      this.updateTerms(cartItems[i])
    }
  }

  handleMinusClick (element) {
    this.toggleLoader(true)

    const data = {
      action: 'update_product_in_cart',
      cart_item_key: element.dataset.cart_item_key,
      quantity: this.getQuantity(element) - 1,
      type: element.dataset.type
    }

    mttAjax('update_product_in_cart', data, this.callbackMinusClick.bind(this))
  }

  callbackMinusClick (response) {
    this.handleCallback(response)

    if (response.success === false) this.errorMessage(0)
  }

  handlePlusClick (element) {
    this.toggleLoader(true)

    const data = {
      action: 'update_product_in_cart',
      cart_item_key: element.dataset.cart_item_key,
      quantity: this.getQuantity(element) + 1,
      type: element.dataset.type
    }

    mttAjax('update_product_in_cart', data, this.callbackPlusClick.bind(this))
  }

  callbackPlusClick (response) {
    this.handleCallback(response)

    if (response.success === false) this.errorMessage(0)
  }

  handleRemoveClick (element) {
    this.toggleLoader(true)

    const data = {
      action: 'remove_product_from_cart',
      cart_item_key: element.dataset.cart_item_key
    }

    mttAjax('remove_product_from_cart', data, this.callbackRemoveClick.bind(this))
  }

  callbackRemoveClick (response) {
    this.handleCallback(response)
    if (typeof response === 'object' && response !== null) {
      if (response.data.cart_count == 0) {
        jQuery('.menu-mini-cart').addClass('empty')
      }
    }

    if (response.success === false) this.errorMessage(1)
  }

  updateTerms (cartItem) {
    const lastSlug = this.getLastAttributeSlug(cartItem)
    if(lastSlug === null) return;
    const lastAttributes = this.getLastAttributeFromVariants(cartItem)
    const liAttributes = jQuery(cartItem).find('.attribute')
    for (let i = 0; i < liAttributes.length; i++) {
      const jQueryLiAttribute = jQuery(liAttributes[i])
      if (jQueryLiAttribute.parent().attr('data-variation') !== lastSlug) continue
      jQueryLiAttribute.hide()
      if (lastAttributes.includes(jQueryLiAttribute.attr('data-value'))) jQueryLiAttribute.show()
    }
  }

  isFirstAttributeDifferent (cartItem) {
    const selectedVariation = jQuery(cartItem).find('[data-selected_product_variation]').data('selected_product_variation')
    const tempSelectedVariation = jQuery(cartItem).find('[data-temp_selected_product_variation]').data('temp_selected_product_variation')
    return Object.values(selectedVariation)[0] !== Object.values(tempSelectedVariation)[0]
  }

  /**
   * Check all variation if the are in stock.
   */
  getAvailableVariants (miniCartItem) {
    const availableVariations = jQuery(miniCartItem).find('[data-product_variations]').data('product_variations')
    const variationsInStock = []
    for (let i = 0; i < availableVariations.length; i++) {
      if (availableVariations[i].is_in_stock === true && availableVariations[i].max_qty !== 0 && availableVariations[i].max_qty) {
        variationsInStock.push(availableVariations[i])
      }
    }

    return variationsInStock
  }

  getLastAttributeSlug (miniCartItem) {
    const tempSelectedVariationWrap = jQuery(miniCartItem).find('[data-temp_selected_product_variation]')
    if(tempSelectedVariationWrap.length !== 1) return null;
    const tempSelectedVariation = tempSelectedVariationWrap.data('temp_selected_product_variation')
    return Object.keys(tempSelectedVariation)[Object.keys(tempSelectedVariation).length - 1].replace('attribute_', '')
  }

  getLastAttributeFromVariants (miniCartItem) {
    const tempSelectedVariation = jQuery(miniCartItem).find('[data-temp_selected_product_variation]').data('temp_selected_product_variation')
    const availableVariants = this.getAvailableVariants(miniCartItem)
    const variants = []
    for (let i = 0; i < availableVariants.length; i++) {
      const attributes = availableVariants[i].attributes
      for (let j = 0; j < Object.keys(attributes).length; j++) {
        if (tempSelectedVariation[Object.keys(attributes)[j]] !== Object.values(attributes)[j]) break
        variants.push(Object.values(attributes)[Object.values(attributes).length - 1])
      }
    }

    return variants
  }

  setTempSelectedVariation (element) {
    const jQueryElement = jQuery(element)
    const jQueryColText = jQueryElement.closest('div.col-text')
    const selectedVariation = jQueryColText.find('[data-temp_selected_product_variation]')
    const selectedVariationValue = selectedVariation.data('temp_selected_product_variation')

    selectedVariationValue['attribute_' + jQueryElement.parent().data('variation')] = jQueryElement.data('value')
    selectedVariation.attr('data-temp_selected_product_variation', JSON.stringify(selectedVariationValue))
    jQueryElement.parent().parent().find('span.variation-value').html(jQueryElement.data('label'))
    this.handleUpdateButton(jQueryColText)
  }

  handleChangeTerms (element) {
    const oldValue = Object.values(jQuery(element).closest('div.col-text').find('[data-temp_selected_product_variation]').data('temp_selected_product_variation'))[0]
    this.setTempSelectedVariation(element)
    const newValue = Object.values(jQuery(element).closest('div.col-text').find('[data-temp_selected_product_variation]').data('temp_selected_product_variation'))[0]

    const miniCartItem = jQuery(element).closest('.mini_cart_item')
    const variationValues = miniCartItem.find('.variation-value')
    if (oldValue !== newValue) jQuery(variationValues[variationValues.length - 1]).html(' ')

    const jQueryColText = jQuery(element).closest('div.col-text')
    this.updateTerms(jQueryColText.closest('.mini_cart_item'))
  }

  handleUpdateButton (colTextElement) {
    colTextElement.find('[data-update_info]').show()
  }

  handleUpdateTerms (element) {
    const jQueryElement = jQuery(element)
    const jQueryColText = jQueryElement.closest('div.col-text')
    const tempSelectedVariation = jQueryColText.find('[data-temp_selected_product_variation]')
    const tempSelectedVariationValue = tempSelectedVariation.data('temp_selected_product_variation')
    const availableVariations = this.getAvailableVariants(jQueryColText)

    for (let i = 0; i < availableVariations.length; i++) {
      let variationFound = false
      for (let j = 0; j < Object.keys(tempSelectedVariationValue).length; j++) {
        if (tempSelectedVariationValue[Object.keys(tempSelectedVariationValue)[j]] === availableVariations[i].attributes[Object.keys(availableVariations[i].attributes)[j]]) {
          variationFound = true
          continue
        }
        variationFound = false
        break
      }

      if (variationFound) {
        this.toggleLoader(true)
        this.handleUpdateProduct(availableVariations[i].variation_id)
        return
      }
    }

    this.errorMessage(2)
  }

  handleUpdateProduct (variationId) {
    const cartItemKey = this.jQueryMenuMiniCart.find('[data-cart_item_key]').data('cart_item_key')
    const productId = this.jQueryMenuMiniCart.find('[data-product_id]').data('product_id')
    const quantity = this.jQueryMenuMiniCart.find('[data-quantity]').data('quantity')

    const data = {
      action: 'add_variable_product_to_cart',
      product_id: productId,
      variant_id: variationId,
      quantity: quantity,
      cart_item_key: cartItemKey
    }

    mttAjax('add_variable_product_to_cart', data, this.callbackUpdateProduct.bind(this))
  }

  callbackUpdateProduct (response) {
    this.handleCallback(response)

    if (response.success === false) this.errorMessage(3)
    this.updateAttributeLists()
  }

  // HELPER METHODS
  toggleLoader (on) {
    if (on) {
      this.miniCart.classList.add('loading')
      const loadingDiv = document.createElement('div')
      loadingDiv.classList.add('loader')
      this.miniCart.appendChild(loadingDiv)
      return
    }
    this.miniCart.classList.remove('loading')
  }

  getQuantity (element) {
    const quantityElement = element.closest('.actions').querySelector('.woocommerce-mini-cart-item__quantity')
    return parseInt(quantityElement.dataset.quantity)
  }

  handleCartHtml (html) {
    const miniCartHtml = new DOMParser().parseFromString(html, 'text/html')
    this.miniCart.innerHTML = miniCartHtml.querySelector('.menu-mini-cart').innerHTML
  }

  handleCartCount (count) {
    const CART_ITEM = document.querySelector('.mtt-header__main-nav-icon-link.mtt-open-cart .count')
    if (CART_ITEM) {
      CART_ITEM.innerHTML = count
    }
  }

  handleCallback (response) {
    this.toggleLoader(false)
    if (typeof response !== 'object' || response === null) return console.warn('Response is not a object!')
    this.handleCartHtml(response.data.mini_cart_html)
    this.handleCartCount(response.data.cart_count)

    if (response.data.hasOwnProperty('ga_key') && response.data.hasOwnProperty('ga_item')) {
      GA4Tracking.pushEvent(response.data.ga_key, [response.data.ga_item])
    }
  }

  errorMessage (id) { // TODO: NEED TO SHOW THAT THE VARIATION DOESN'T EXISTS OR THERE WAS A PROBLEM WITH CHANGING THE PRODUCT!!!!
    console.log('No variation found')
    switch (id) {
      case 0:
        alert('Det var ikke muligt at ændre antallet på produktet.')
        break
      case 1:
        alert('Det var ikke muligt at fjerne produktet.')
        break
      case 2:
        alert('Det var ikke muligt at ændre produktet, da produktet finde ikke.')
        break
      case 3:
        alert('Det var ikke muligt at ændre produktet, da det nye produkt ikke er på lager eller ikke har den valgte lagerbeholdning.')
        break
      default:
        alert('Der skete en fejl i kurven.')
        break
    }
  }
}
